import * as jsonpatch from "fast-json-patch";

class PatchUtils {
  static trimValues = (operations, oldEntity) => {
    return operations
      .filter(op => PatchUtils.validateOperation(op, oldEntity))
      .map(op => PatchUtils.transformOperation(op, oldEntity));
  };

  /**
   * Compares new and old entity. Returns json-patch operations for patch request.
   * It trims values so that unimportant pieces are not sent and only
   * values specified in oldEntity (so called observed values) are tracked.
   */
  static compare = (oldEntity, entity) => {
    return PatchUtils.trimValues(
      jsonpatch.compare(oldEntity, entity),
      oldEntity
    );
  };

  static validateOperation = (op, oldEntity) => {
    const pathTree = op.path.split("/");
    const lastPath = pathTree[pathTree.length - 1];
    const validEnd =
      lastPath === "id" ||
      lastPath === "dateFrom" ||
      lastPath === "dateTo" ||
      !isNaN(lastPath);
    const hasKey = Object.keys(oldEntity).some(key => pathTree[1] === key);
    return hasKey && (pathTree.length <= 2 || validEnd);
  };

  static transformOperation = (op, oldEntity) => {
    if (op.value && typeof op.value === "object") {
      if (op.value.id) {
        op.value = { id: op.value.id };
      }
    } else if (op.path.endsWith("id")) {
      const pathTree = op.path.split("/");
      pathTree.pop();
      op.path = pathTree.join("/");
      op.value = { id: op.value };
    }

    let arrayId = op.path.slice(op.path.length - 1);
    if (!isNaN(arrayId)) {
      arrayId = parseInt(arrayId);
      const pathTree = op.path.split("/");
      const oldValue = oldEntity[pathTree[1]];
      if (
        !oldValue ||
        (Array.isArray(oldValue) && oldValue.length <= arrayId)
      ) {
        op.path = op.path.replace(/.$/, "-");
      }
    }
    return op;
  };
}

export default PatchUtils;
